module.exports = __webpack_public_path__ + "static/img/new-folder.5e176452.png";